import { API_PATHS } from "../constants/api-paths";
import { IResponse, encryptedRequest } from "../core/api.client";

interface IApiResponseFederatedLogin {
  federatedToken: string;
}

export const federatedLogin = async (
  mobileNo: string,
  p_token?: string,
  prodCode?: string
): Promise<IResponse<IApiResponseFederatedLogin>> => {
  const response = await encryptedRequest<IApiResponseFederatedLogin>({
    method: "POST",
    url: API_PATHS.federatedLogin,
    data: { mobileNo, p_token, prodCode },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};

export const federatedAuthorize = async (
  mobileNo: string,
  federatedToken: string
): Promise<IResponse<null>> => {
  const response = await encryptedRequest<null>({
    method: "POST",
    url: API_PATHS.federatedAuthorize,
    data: { mobileNo, federatedToken },
  });

  if (response.statusCode !== 90) {
    throw new Error(response.message);
  }

  return response;
};
